<template>
  <div :id="$attrs['id']" :class="[$attrs['class'], gridClasses, 'gravatar__wrapper']">
    <img v-if="hash === null || hash === undefined || hash === 'null' || hash === 'undefined'"
         :style="imgStyle"
         src="https://hotelmeister-1265.firebaseapp.com/assets/static/img/icons/genderneutral.png"
         loading="lazy"
         class="gravatar">
    <img v-else-if="hash !== null && type === 'Guest' && gender === 'Female'"
         :src="`https://www.gravatar.com/avatar/${hash}?d=https%3A%2F%2Fhotelmeister-1265.firebaseapp.com%2Fassets%2Fstatic%2Fimg%2Ficons%2Fgirl.png`"
         :style="imgStyle"
         loading="lazy"
         class="gravatar">
    <img v-else-if="hash !== null && type === 'Guest' && gender === 'Male'"
         :src="`https://www.gravatar.com/avatar/${hash}?d=https%3A%2F%2Fhotelmeister-1265.firebaseapp.com%2Fassets%2Fstatic%2Fimg%2Ficons%2Fdude.png`"
         :style="imgStyle"
         loading="lazy"
         class="gravatar">
    <img v-else-if="hash !== null && type === 'Guest'"
         :src="`https://www.gravatar.com/avatar/${hash}?d=https%3A%2F%2Fhotelmeister-1265.firebaseapp.com%2Fassets%2Fstatic%2Fimg%2Ficons%2Fgenderneutral.png`"
         :style="imgStyle"
         loading="lazy"
         class="gravatar">
    <img v-else-if="hash !== null"
         :src="`https://www.gravatar.com/avatar/${hash}?d=https%3A%2F%2Fhotelmeister-1265.firebaseapp.com%2Fassets%2Fstatic%2Fimg%2Ficons%2Fcompany.png`"
         :style="imgStyle"
         loading="lazy"
         class="gravatar">
    <img v-else-if="type !== 'Guest'"
         :style="imgStyle"
         src="https://hotelmeister-1265.firebaseapp.com/assets/static/img/icons/company.png"
         loading="lazy"
         class="gravatar">
    <img v-else-if="type === 'Guest' && gender === 'Male'"
         :style="imgStyle"
         src="https://hotelmeister-1265.firebaseapp.com/assets/static/img/icons/dude.png"
         loading="lazy"
         class="gravatar">
    <img v-else-if="type === 'Guest' && gender === 'Female'"
         :style="imgStyle"
         src="https://hotelmeister-1265.firebaseapp.com/assets/static/img/icons/girl.png"
         loading="lazy"
         class="gravatar">
    <img v-else
         :style="imgStyle"
         src="https://hotelmeister-1265.firebaseapp.com/assets/static/img/icons/genderneutral.png"
         loading="lazy"
         class="gravatar">
  </div>
</template>

<script>
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'Gravatar',

  mixins: [GridMixin],

  props: {
    hash: String,
    type: String,
    gender: String,
    size: {
      type: Number,
      default: 64,
    },
    align: {
      type: String,
      default: 'default',
    },
  },

  computed: {
    imgStyle: function () {
      if (this.align === 'left') {
        return {
          maxHeight: `${this.size}px`,
          maxWidth: `${this.size}px`,
          position: 'absolute',
          left: '0',
          top: '50%',
          transform: 'translateY(-50%)',
        };
      } else if (this.align === 'right') {
        return {
          maxHeight: `${this.size}px`,
          maxWidth: `${this.size}px`,
          position: 'absolute',
          right: '0',
          top: '50%',
          marginTop: '-0.8rem',
          transform: 'translateY(-50%)',
        };
      } else if (this.align === 'center') {
        return {
          maxHeight: `${this.size}px`,
          maxWidth: `${this.size}px`,
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        };
      } else {
        return {
          maxHeight: `${this.size}px`,
          maxWidth: `${this.size}px`,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~styles/import';

  .gravatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 1px solid $gray;
    background-color: white;
    &__wrapper {
      &--inline {
        position: relative;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/Gravatar.vue